import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chatbot.embed');
import { validChatHostEnvelope } from "src/libs/portal/season/util/chat-embed";
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { AlsphereChat } from "src/libs/portal/fab/alsphere-chat";


const BRIDGE_CHANNEL = 'nanofab.floating-chat';
const BRIDGE_VERSION = 1;
const MAX_PAYLOAD_BYTES = 64 * 1024;
const MAX_TEXT_LENGTH = 8000;
const MAX_TABLE_COLUMNS = 8;
const MAX_TABLE_ROWS = 20;
const MAX_CHART_POINTS = 40;
const INSTANCE_ID_PATTERN = /^nfcb-[0-9a-f]{32}$/;
const REQUEST_ID_PATTERN = /^req-[0-9a-f]{32}$/;
const SERVICE_INIT_TIMEOUT_MS = 5000;


@Component({
    selector: 'wiz-page-chatbot-embed',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chatbot.embed/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  color: #152437;
  background: transparent;
  font-family: Pretendard, SUIT, Inter, system-ui, sans-serif;
}

* {
  box-sizing: border-box;
}

.nfcb-embed {
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
  width: 100%;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}

.nfcb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 68px;
  padding: 12px 16px;
  color: #fff;
  background: linear-gradient(135deg, #083d78 0%, #1268c4 70%, #2086df 100%);
}

.nfcb-brand,
.nfcb-connection,
.nfcb-brand > span:last-child,
.nfcb-live-process header,
.nfcb-review header,
.nfcb-table header,
.nfcb-chart header,
.nfcb-composer-actions,
.nfcb-result-actions {
  display: flex;
  align-items: center;
}

.nfcb-brand {
  gap: 10px;
  min-width: 0;
}

.nfcb-brand > span:last-child {
  align-items: flex-start;
  flex-direction: column;
  min-width: 0;
}

.nfcb-brand strong {
  font-size: 15px;
  letter-spacing: -0.02em;
}

.nfcb-brand small {
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
}

.nfcb-face {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 14px;
  background: #fff;
}

.nfcb-face img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nfcb-connection {
  flex: 0 0 auto;
  gap: 5px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.72);
}

.nfcb-connection span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fbbf24;
}

.nfcb-connection.is-connected span {
  background: #74e6a4;
  box-shadow: 0 0 0 4px rgba(116, 230, 164, 0.15);
}

.nfcb-blocked {
  margin: 20px;
  padding: 22px;
  border: 1px solid #fecaca;
  border-radius: 16px;
  color: #991b1b;
  background: #fff7f7;
}

.nfcb-blocked p {
  margin: 8px 0 0;
  font-size: 13px;
}

.nfcb-capabilities {
  display: flex;
  gap: 6px;
  padding: 10px 12px;
  overflow-x: auto;
  border-bottom: 1px solid #e7edf5;
  background: #f7faff;
  scrollbar-width: thin;
}

.nfcb-capabilities button {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 5px;
  min-height: 30px;
  padding: 5px 9px;
  border: 1px solid #d5e3f3;
  border-radius: 999px;
  color: #31506f;
  background: #fff;
  font: inherit;
  font-size: 11px;
  cursor: pointer;
}

.nfcb-capabilities button:hover {
  border-color: #7bb4e8;
  color: #0c5fae;
}

.nfcb-capabilities button:disabled {
  opacity: 0.5;
  cursor: default;
}

.nfcb-capabilities span {
  font-size: 9px;
  font-weight: 800;
  color: #1268c4;
}

.nfcb-messages {
  min-height: 0;
  padding: 14px;
  overflow-y: auto;
  background: linear-gradient(180deg, #f8fafc, #f3f7fb);
}

.nfcb-message {
  width: min(92%, 390px);
  margin: 0 auto 10px 0;
  padding: 11px 12px;
  border: 1px solid #dfe8f2;
  border-radius: 5px 16px 16px 16px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(18, 52, 86, 0.06);
}

.nfcb-message.is-user {
  width: fit-content;
  max-width: 86%;
  margin-right: 0;
  margin-left: auto;
  border-color: #1268c4;
  border-radius: 16px 5px 16px 16px;
  color: #fff;
  background: #1268c4;
}

.nfcb-message.is-review {
  border-color: #bfdbfe;
  background: #fafdff;
}

.nfcb-message.is-error {
  border-color: #fecaca;
  color: #991b1b;
  background: #fff7f7;
}

.nfcb-message-copy {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 13px;
  line-height: 1.55;
}

.nfcb-live-process {
  display: grid;
  gap: 9px;
}

.nfcb-live-process header {
  justify-content: space-between;
  gap: 8px;
}

.nfcb-live-process header strong {
  color: #173f68;
  font-size: 12px;
}

.nfcb-live-process header small {
  color: #64748b;
  font-size: 9px;
}

.nfcb-live-process ol {
  display: grid;
  gap: 7px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nfcb-live-process li {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: start;
  gap: 7px;
  color: #64748b;
}

.nfcb-live-process li > span {
  width: 8px;
  height: 8px;
  margin-top: 4px;
  border: 2px solid #bfcee0;
  border-radius: 50%;
  background: #fff;
}

.nfcb-live-process li.is-checked > span {
  border-color: #3b82f6;
  background: #3b82f6;
}

.nfcb-live-process li.is-running > span {
  border-color: #1268c4;
  box-shadow: 0 0 0 4px rgba(18, 104, 196, 0.12);
  animation: nfcb-pulse 1s ease-in-out infinite;
}

.nfcb-live-process li.is-submitted > span {
  border-color: #6aa4d8;
  background: #dcecff;
}

.nfcb-live-process li div {
  display: grid;
  gap: 1px;
  min-width: 0;
}

.nfcb-live-process li strong {
  color: #284964;
  font-size: 10px;
  line-height: 1.4;
}

.nfcb-live-process li small {
  overflow-wrap: anywhere;
  font-size: 9px;
  line-height: 1.4;
}

.nfcb-live-process li em {
  padding: 2px 5px;
  border-radius: 999px;
  color: #456781;
  background: #edf4fa;
  font-size: 8px;
  font-style: normal;
  white-space: nowrap;
}

.nfcb-review {
  display: grid;
  gap: 10px;
}

.nfcb-review header,
.nfcb-table header,
.nfcb-chart header {
  justify-content: space-between;
  gap: 8px;
}

.nfcb-review header strong,
.nfcb-table header strong,
.nfcb-chart header strong {
  font-size: 12px;
}

.nfcb-review header small,
.nfcb-table header small,
.nfcb-chart header small {
  color: #64748b;
  font-size: 10px;
}

.nfcb-review dl {
  display: grid;
  gap: 6px;
  margin: 0;
}

.nfcb-review dl div {
  display: grid;
  grid-template-columns: 46px 1fr;
  gap: 8px;
}

.nfcb-review dt {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.nfcb-review dd {
  margin: 0;
  color: #23364b;
  font-size: 11px;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.nfcb-review-reasons {
  margin: 0;
  padding: 8px 10px 8px 24px;
  border-radius: 9px;
  color: #854d0e;
  background: #fff8e7;
  font-size: 10px;
  line-height: 1.45;
}

.nfcb-review-actions {
  justify-content: flex-end;
  gap: 7px;
}

.nfcb-review-actions button,
.nfcb-result-actions button,
.nfcb-composer-actions button {
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid #cad8e7;
  border-radius: 9px;
  color: #31506f;
  background: #fff;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.nfcb-review-actions button.is-primary,
.nfcb-result-actions button.is-primary,
.nfcb-composer-actions button.is-primary {
  border-color: #1268c4;
  color: #fff;
  background: #1268c4;
}

.nfcb-review-actions button:disabled,
.nfcb-composer-actions button:disabled {
  opacity: 0.5;
  cursor: default;
}

.nfcb-table,
.nfcb-chart {
  display: grid;
  gap: 9px;
  margin-top: 11px;
  padding-top: 10px;
  border-top: 1px solid #e6edf5;
}

.nfcb-table > div {
  overflow-x: auto;
}

.nfcb-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
}

.nfcb-table th,
.nfcb-table td {
  padding: 6px;
  border-bottom: 1px solid #e7edf5;
  text-align: left;
  white-space: nowrap;
}

.nfcb-table th {
  color: #48647f;
  background: #f4f8fc;
}

.nfcb-chart-bars {
  display: flex;
  align-items: flex-end;
  gap: 7px;
  min-height: 112px;
  overflow-x: auto;
}

.nfcb-chart-point {
  display: grid;
  grid-template-rows: 20px 80px 24px;
  align-items: end;
  justify-items: center;
  flex: 1 0 42px;
  min-width: 42px;
}

.nfcb-chart-point span {
  color: #47647f;
  font-size: 9px;
}

.nfcb-chart-track {
  position: relative;
  width: 100%;
  height: 80px;
}

.nfcb-chart-zero {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: #94a3b8;
}

.nfcb-chart-track i {
  position: absolute;
  left: 50%;
  display: block;
  width: 22px;
  transform: translateX(-50%);
  border-radius: 3px;
  background: #1268c4;
}

.nfcb-chart-track i.is-negative {
  background: #b45309;
}

.nfcb-chart-track i.is-zero {
  display: none;
}

.nfcb-chart-caption {
  margin: 0;
  color: #526b83;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.nfcb-chart-source {
  color: #64748b;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.nfcb-chart-point b {
  max-width: 62px;
  overflow: hidden;
  color: #526b83;
  font-size: 9px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nfcb-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 9px;
}

.nfcb-meta span {
  padding: 3px 6px;
  border-radius: 999px;
  color: #58718a;
  background: #edf3f8;
  font-size: 9px;
}

.nfcb-citations {
  display: grid;
  gap: 8px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #e6edf5;
  font-size: 12px;
}

.nfcb-source {
  display: grid;
  gap: 0;
  min-width: 0;
  padding: 0;
  border-radius: 8px;
  background: #f4f8fc;
  overflow-wrap: anywhere;
}

.nfcb-source a {
  color: #1268c4;
  font-weight: 700;
  text-decoration: underline;
}

.nfcb-source small {
  color: #58718a;
  font-size: 12px;
}

.nfcb-source p {
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.5;
}

.nfcb-source-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 9px;
  border: 0;
  border-radius: 8px;
  color: #31506f;
  background: transparent;
  text-align: left;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.nfcb-source-title:focus-visible {
  outline: 2px solid #1268c4;
  outline-offset: 2px;
}

.nfcb-source-detail {
  display: grid;
  gap: 7px;
  padding: 0 9px 10px;
}

.nfcb-source dl {
  margin: 6px 0;
}

.nfcb-answer-attribution {
  display: grid;
  gap: 4px;
  margin-top: 12px;
  padding-top: 9px;
  border-top: 1px solid #e6edf5;
  color: #58718a;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.nfcb-answer-attribution strong {
  color: #31506f;
}

.nfcb-markdown {
  white-space: normal;
  line-height: 1.65;
}

:host ::ng-deep .nfcb-markdown p {
  margin: 0 0 10px;
}
:host ::ng-deep .nfcb-markdown p:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .nfcb-markdown ul, :host ::ng-deep .nfcb-markdown ol {
  margin: 8px 0 12px;
  padding-left: 22px;
}
:host ::ng-deep .nfcb-markdown li {
  margin: 5px 0;
}
:host ::ng-deep .nfcb-markdown strong {
  color: #173f68;
  font-weight: 750;
}
:host ::ng-deep .nfcb-markdown h1, :host ::ng-deep .nfcb-markdown h2, :host ::ng-deep .nfcb-markdown h3, :host ::ng-deep .nfcb-markdown h4 {
  margin: 14px 0 7px;
  font-size: 14px;
  line-height: 1.4;
}
:host ::ng-deep .nfcb-markdown h1:first-child, :host ::ng-deep .nfcb-markdown h2:first-child, :host ::ng-deep .nfcb-markdown h3:first-child, :host ::ng-deep .nfcb-markdown h4:first-child {
  margin-top: 0;
}
:host ::ng-deep .nfcb-markdown blockquote {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #bfdbfe;
  color: #526b83;
}
:host ::ng-deep .nfcb-markdown code {
  padding: 1px 3px;
  border-radius: 3px;
  background: #edf3f8;
  font-size: 0.95em;
}
:host ::ng-deep .nfcb-markdown pre {
  max-width: 100%;
  overflow-x: auto;
  padding: 9px;
  border-radius: 7px;
  background: #edf3f8;
  white-space: pre;
}
:host ::ng-deep .nfcb-markdown a {
  color: #1268c4;
  text-decoration: underline;
}

.nfcb-source dl {
  display: grid;
  gap: 4px;
}

.nfcb-source dl div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
  gap: 8px;
}

.nfcb-source dt {
  color: #58718a;
}

.nfcb-source dd {
  margin: 0;
}

.nfcb-result-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 10px;
}

.nfcb-message.is-loading {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #58718a;
}

.nfcb-message.is-loading span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4f91cf;
  animation: nfcb-bounce 0.9s infinite alternate;
}

.nfcb-message.is-loading span:nth-child(2) {
  animation-delay: 0.15s;
}

.nfcb-message.is-loading span:nth-child(3) {
  animation-delay: 0.3s;
}

.nfcb-message.is-loading strong {
  margin-left: 4px;
  font-size: 10px;
}

.nfcb-composer {
  display: grid;
  gap: 8px;
  padding: 11px 12px 12px;
  border-top: 1px solid #dfe8f2;
  background: #fff;
}

.nfcb-context {
  display: flex;
  gap: 6px;
  min-width: 0;
  color: #64748b;
  font-size: 10px;
}

.nfcb-context strong {
  overflow: hidden;
  color: #31506f;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nfcb-composer textarea {
  width: 100%;
  min-height: 54px;
  max-height: 130px;
  resize: vertical;
  padding: 9px 10px;
  border: 1px solid #cad8e7;
  border-radius: 11px;
  outline: none;
  color: #1e344b;
  background: #fbfdff;
  font: inherit;
  font-size: 12px;
  line-height: 1.45;
}

.nfcb-composer textarea:focus {
  border-color: #4d9adf;
  box-shadow: 0 0 0 3px rgba(18, 104, 196, 0.1);
}

.nfcb-composer-actions {
  gap: 6px;
}

.nfcb-composer-actions select {
  min-width: 0;
  padding: 7px 8px;
  border: 1px solid #cad8e7;
  border-radius: 9px;
  color: #31506f;
  background: #fff;
  font: inherit;
  font-size: 10px;
}

.nfcb-composer-actions .nfcb-agent-select {
  flex: 0 1 106px;
  margin-right: auto;
}

@keyframes nfcb-bounce {
  to {
    transform: translateY(-4px);
    opacity: 0.45;
  }
}
@keyframes nfcb-pulse {
  50% {
    opacity: 0.45;
    transform: scale(0.82);
  }
}
@media (max-width: 520px) {
  .nfcb-header {
    min-height: 60px;
    padding: 9px 11px;
  }
  .nfcb-face {
    width: 36px;
    height: 36px;
  }
  .nfcb-connection {
    display: none;
  }
  .nfcb-capabilities {
    padding: 8px;
  }
  .nfcb-messages {
    padding: 10px;
  }
  .nfcb-message {
    width: 96%;
  }
  .nfcb-composer-actions {
    flex-wrap: wrap;
  }
  .nfcb-composer-actions select {
    flex: 1 0 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .nfcb-message.is-loading span,
  .nfcb-live-process li.is-running > span {
    animation: none;
  }
}
.nfcb-source-image-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0;
}
.nfcb-source-image-toolbar strong {
  flex: 1;
  font-size: 13px;
}
.nfcb-source-image-toolbar button {
  width: 30px;
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #1d4ed8;
  background: #fff;
  cursor: pointer;
}
.nfcb-source-image-toolbar button:disabled {
  opacity: 0.4;
  cursor: default;
}
.nfcb-source-image-toolbar span {
  font-size: 12px;
}

.nfcb-source-image-viewport {
  max-height: 65vh;
  overflow: auto;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #e2e8f0;
}
.nfcb-source-image-viewport img {
  display: block;
  max-width: none;
  height: auto;
  margin: 0;
  background: #fff;
}

.nfcb-retrieval {
  display: grid;
  gap: 8px;
  margin: 14px 0 0;
  padding: 12px;
  border: 1px solid #dbe4f0;
  border-radius: 8px;
  background: #f8fafc;
}
.nfcb-retrieval > div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 10px;
}
.nfcb-retrieval dt {
  font-weight: 600;
  color: #475569;
  font-size: 12px;
}
.nfcb-retrieval dd {
  margin: 0;
  color: #334155;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.nf-execution-events, .nf-sources-collection {
  margin-top: 12px;
  border: 1px solid #dce4ef;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
  color: #334155;
}
.nf-execution-events > summary, .nf-sources-collection > summary {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.nf-execution-events > summary:focus-visible, .nf-sources-collection > summary:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 3px;
}

.nf-sources-summary small {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.nf-source-support {
  margin: 7px 0;
  font-size: 12px;
  line-height: 1.6;
  color: #475569;
}

.nf-current-progress {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  align-items: center;
  gap: 4px 14px;
  min-width: 0;
  padding: 6px 0;
  color: #334155;
  font-size: 14px;
  line-height: 24px;
}
.nf-current-progress > .nf-current-tool {
  grid-column: 1/-1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
}
.nf-current-progress > small {
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.nf-current-progress > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.nf-current-progress[data-status=completed] > small {
  color: #15803d;
}
.nf-current-progress[data-status=failed] > small {
  color: #b91c1c;
}
.nf-current-progress[data-status=retrying] > small, .nf-current-progress[data-status=no_data] > small, .nf-current-progress[data-status=skipped] > small, .nf-current-progress[data-status=fallback] > small {
  color: #92400e;
}

.nf-execution-events ol {
  padding: 0;
  list-style: none;
  max-height: 220px;
  overflow-y: auto;
}

.nf-execution-events li {
  display: flex;
  gap: 8px;
  padding: 5px 0;
  font-size: 12px;
  line-height: 1.6;
}

.nf-execution-events li small {
  flex: 0 0 48px;
  color: #2563eb;
}

.nf-execution-events li[data-status=failed] small {
  color: #b91c1c;
}

.nf-execution-events li[data-status=retrying] small,
.nf-execution-events li[data-status=no_data] small {
  color: #92400e;
}

.nf-answer-warning {
  margin-top: 8px;
  color: #92400e;
  font-size: 12px;
  line-height: 1.6;
}

.nf-answer-attribution {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid #e2e8f0;
  font-size: 12px;
  color: #64748b;
}

.nf-streaming-answer {
  margin: 8px 0;
  color: #2563eb;
  font-size: 12px;
  line-height: 1.6;
}

.alsphere-chat-attachments {
  margin-top: 8px;
  font-size: 11px;
  color: #536579;
}
.alsphere-chat-attachments .alsphere-chat-attachment-actions, .alsphere-chat-attachments .alsphere-chat-file, .alsphere-chat-attachments .alsphere-chat-followup {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
  min-width: 0;
}
.alsphere-chat-attachments .alsphere-chat-file > span {
  overflow-wrap: anywhere;
}
.alsphere-chat-attachments button {
  border: 1px solid #bdd0e5;
  border-radius: 8px;
  background: #f1f7ff;
  color: #15539a;
  padding: 4px 8px;
  font-size: 11px;
  white-space: nowrap;
  cursor: pointer;
}
.alsphere-chat-attachments button:disabled {
  opacity: 0.45;
  cursor: default;
}
.alsphere-chat-attachments p[role=alert] {
  margin: 5px 0 0;
  color: #b42318;
  overflow-wrap: anywhere;
}`],
})
export class PageChatbotEmbedComponent implements OnInit, OnDestroy {
    public alsphereChat = new AlsphereChat({
        messages: () => this.messages,
        input: value => { this.input = value; },
        busy: value => { this.busy = value; this.busyLabel = value ? '알세미 모델을 확인하고 있어요' : ''; },
        render: async () => { await this.service.render(); this.scrollToBottom(); this.notifyResize(); },
        completed: async (question, result, error) => {
            if (!result) {
                if (error) this.emitError(error, this.currentRequestId || this.requestId());
                else this.postToParent('ERROR', this.currentRequestId || this.requestId(), { code: 'QUERY_FAILED', message: '질문을 처리하지 못했습니다. 다시 시도해 주세요.', retryable: true });
                this.currentRequestId = '';
                return;
            }
            const requestId = REQUEST_ID_PATTERN.test(this.currentRequestId) ? this.currentRequestId : this.requestId();
            this.currentRequestId = '';
            const message = this.messages[this.messages.length - 1];
            const publicResult = this.publicResult({ answer: result.reply, status: 'completed' }, question, requestId, null, null);
            message.publicResult = publicResult;
            message.requestId = requestId;
            this.lastPublicResult = publicResult;
            this.postToParent('RESULT', requestId, publicResult);
        }
    });

    public bridgeReady: boolean = false;
    public bridgeBlocked: boolean = false;
    public input: string = '';
    public busy: boolean = false;
    public busyLabel: string = '';
    public agentMode: string = 'auto';
    public messages: any[] = [{
        role: 'assistant',
        kind: 'text', intro: true,
        content: '공정 데이터와 데이터셋을 찾고, AI 모델 실행 결과를 분석·요약·시각화해 드립니다.'
    }];
    public pendingReview: any = null;
    public hostContextLabel: string = '';
    public readonly alsphereExample = { agentMode: 'auto', prompt: '알세미 증착 모델로 온도 350, 압력 3.5 조건을 예측하고 싶어요' };
    public readonly capabilityPrompts: any[] = [
        { marker: 'E', label: '식각 선택비', agentMode: 'simple', prompt: '반도체 식각 공정에서 선택비와 균일도에 영향을 주는 주요 요인은 무엇인가요?' },
        { marker: 'D', label: '장비 검색', agentMode: 'data_search', prompt: '식각 공정에 사용하는 장비 목록을 보여줘.' },
        { marker: 'CMP', label: 'CMP 결함', agentMode: 'simple', prompt: 'CMP 공정에서 결함이 증가할 때 우선 확인할 변수는 무엇인가요?' },
        { marker: 'VM', label: 'AI 가상계측', agentMode: 'ai_model', prompt: 'CMP 공정 데이터로 가상계측 모델을 실행해 두께를 예측해줘.' }
    ];

    private parentOrigin: string = '';
    private instanceId: string = '';
    private bridgeInitialized: boolean = false;
    private activeController: AbortController | null = null;
    private destroyed: boolean = false;
    private serviceInitializationSettled: boolean = false;
    private pendingInitEvent: MessageEvent | null = null;
    private conversationBinding: any = null;
    private currentRequestId: string = '';
    private seenHostRequests: Set<string> = new Set();
    private lastPublicResult: any = null;
    private hostContext: any = null;
    private handshakeTimer: any = null;
    private processNarrationTimer: any = null;
    private sourceDetailController: AbortController | null = null;
    private sourceDetailSequence: number = 0;
    private sourceDetailMessage: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        const params = new URLSearchParams(location.search || '');
        const requestedParentOrigin = this.normalizeOrigin(params.get('parentOrigin'));
        const configuredParentOrigin = this.normalizeOrigin(
            document.querySelector('meta[name="nanofab-chat-parent-origin"]')?.getAttribute('content')
        );
        this.parentOrigin = requestedParentOrigin === configuredParentOrigin ? requestedParentOrigin : '';
        this.instanceId = String(params.get('instanceId') || '').trim().toLowerCase();
        this.bridgeBlocked = !this.parentOrigin || !INSTANCE_ID_PATTERN.test(this.instanceId) || window.parent === window;
        if (!this.bridgeBlocked) {
            this.handshakeTimer = window.setTimeout(async () => {
                if (this.bridgeInitialized) return;
                this.bridgeBlocked = true;
                await this.service.render();
            }, 8000);
            window.setTimeout(() => {
                if (this.destroyed) return;
                this.postToParent('HELLO', null, {
                    readyForInit: true,
                    capabilities: ['data_search', 'dataset_search', 'model', 'analysis', 'summary', 'visualization']
                }, true);
                this.notifyResize();
            }, 0);
        }
        let initializationTimer: any = null;
        const initialization = Promise.resolve()
            .then(() => this.service.init())
            .catch(() => null);
        await Promise.race([
            initialization,
            new Promise<void>((resolve) => {
                initializationTimer = window.setTimeout(
                    () => resolve(),
                    SERVICE_INIT_TIMEOUT_MS
                );
            })
        ]);
        if (initializationTimer) window.clearTimeout(initializationTimer);
        if (this.destroyed) return;
        this.serviceInitializationSettled = true;
        try {
            await this.service.render();
        } catch (_error) { }
        const pendingInitEvent = this.pendingInitEvent;
        this.pendingInitEvent = null;
        if (pendingInitEvent) await this.handleBridgeMessage(pendingInitEvent);
    }

    public ngOnDestroy() {
        this.alsphereChat.destroy();
        this.destroyed = true;
        this.closeSourceDetail();
        this.pendingInitEvent = null;
        if (this.activeController) this.activeController.abort();
        if (this.handshakeTimer) window.clearTimeout(this.handshakeTimer);
        this.stopProcessNarration();
    }

    @HostListener('window:message', ['$event'])
    public async handleBridgeMessage(event: MessageEvent) {
        if (
            this.bridgeBlocked
            || event.origin !== this.parentOrigin
            || event.source !== window.parent
            || !this.validEnvelope(event.data)
        ) return;

        const envelope: any = event.data;
        if (envelope.type === 'INIT' && !this.serviceInitializationSettled) {
            if (!this.pendingInitEvent) this.pendingInitEvent = event;
            return;
        }
        if (envelope.type !== 'INIT' && !this.bridgeInitialized) return;
        const replayKey = `${envelope.type}:${envelope.requestId || ''}`;
        if (envelope.requestId && this.seenHostRequests.has(replayKey)) return;
        if (envelope.requestId) {
            this.seenHostRequests.add(replayKey);
            if (this.seenHostRequests.size > 100) {
                const oldest = this.seenHostRequests.values().next();
                if (!oldest.done) this.seenHostRequests.delete(oldest.value);
            }
        }

        if (envelope.type === 'INIT') {
            if (this.bridgeInitialized) return;
            this.bridgeInitialized = true;
            this.bridgeReady = true;
            if (this.handshakeTimer) window.clearTimeout(this.handshakeTimer);
            this.applyHostContext(envelope.payload?.context);
            this.postToParent('ACK', envelope.requestId, { acknowledgedType: 'INIT' });
            this.postToParent('READY', envelope.requestId, {
                authenticated: this.service.auth?.status === true,
                capabilities: ['data_search', 'dataset_search', 'model', 'analysis', 'summary', 'visualization']
            });
        } else if (envelope.type === 'HOST_CONTEXT') {
            this.applyHostContext(envelope.payload?.context);
            this.postToParent('ACK', envelope.requestId, { acknowledgedType: 'HOST_CONTEXT' });
        } else if (envelope.type === 'QUERY') {
            if (this.busy || this.pendingReview) {
                this.postToParent('ERROR', envelope.requestId, { code: 'CHAT_BUSY', message: '진행 중인 질문을 완료하거나 새 대화를 시작해 주세요.', retryable: true });
                return;
            }
            this.postToParent('ACK', envelope.requestId, { acknowledgedType: 'QUERY' });
            const query = this.safeString(envelope.payload?.query, 2000);
            if (query && !this.busy && !this.pendingReview) {
                this.input = query;
                this.currentRequestId = envelope.requestId;
                await this.planQuestion();
            }
        } else if (envelope.type === 'RESET') {
            await this.resetConversation();
            this.postToParent('ACK', envelope.requestId, { acknowledgedType: 'RESET' });
        }
        await this.service.render();
        this.notifyResize();
    }

    private normalizeOrigin(value: any) {
        try {
            const parsed = new URL(String(value || ''));
            if (!['http:', 'https:'].includes(parsed.protocol) || parsed.username || parsed.password) return '';
            return parsed.origin;
        } catch (_error) {
            return '';
        }
    }

    private validEnvelope(value: any) {
        if (!validChatHostEnvelope(value, this.instanceId)) return false;
        if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
        if (
            value.channel !== BRIDGE_CHANNEL
            || value.version !== BRIDGE_VERSION
            || value.instanceId !== this.instanceId
            || !['INIT', 'HOST_CONTEXT', 'QUERY', 'RESET'].includes(value.type)
        ) return false;
        if (!REQUEST_ID_PATTERN.test(String(value.requestId || ''))) return false;
        try {
            return JSON.stringify(value).length <= MAX_PAYLOAD_BYTES;
        } catch (_error) {
            return false;
        }
    }

    private postToParent(type: string, requestId: string | null, payload: any, beforeInit: boolean = false) {
        if (!this.parentOrigin || this.bridgeBlocked || (!this.bridgeInitialized && !beforeInit)) return;
        const envelope = {
            channel: BRIDGE_CHANNEL,
            version: BRIDGE_VERSION,
            type,
            requestId: requestId || null,
            instanceId: this.instanceId,
            payload: payload || {}
        };
        try {
            if (JSON.stringify(envelope).length > MAX_PAYLOAD_BYTES) return;
            window.parent.postMessage(envelope, this.parentOrigin);
        } catch (_error) { }
    }

    private requestId() {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return 'req-' + Array.from(bytes).map((value: number) => value.toString(16).padStart(2, '0')).join('');
    }

    private applyHostContext(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return;
        this.hostContext = {
            path: this.safeString(value.path, 300),
            title: this.safeString(value.title, 160),
            selection: this.safeString(value.selection, 500)
        };
        this.hostContextLabel = this.hostContext.title || this.hostContext.path;
    }

    public async selectCapability(item: any) {
        if (!this.bridgeReady || this.busy || this.pendingReview) return;
        this.input = this.safeString(item?.prompt, 2000);
        this.agentMode = this.safeAgentMode(item?.agentMode);
        await this.service.render();
    }

    public async updateChatInput(value: string) {
        this.input = value;
        await this.service.render();
    }

    public handleKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey || (event as any).isComposing) return;
        event.preventDefault();
        void this.planQuestion();
    }

    public async planQuestion() {
        const question = this.safeString(this.input, 2000).trim();
        if (!this.bridgeReady || (!question && !this.alsphereChat.file) || this.busy || this.pendingReview) return;
        if (await this.alsphereChat.trySend(question)) return;
        const requestId = REQUEST_ID_PATTERN.test(this.currentRequestId) ? this.currentRequestId : this.requestId();
        this.currentRequestId = '';
        const context = this.conversationContext();
        this.messages.push({ role: 'user', kind: 'text', content: question });
        this.input = '';
        this.busy = true;
        this.busyLabel = '질문 의도와 실행 도구를 확인하고 있어요';
        const responseMessage: any = {
            role: 'assistant', kind: 'progress', content: '', question, requestId,
            processSteps: this.service.chatPresentation.initialProcessSteps({ agentMode: this.agentMode })
        };
        this.messages.push(responseMessage);
        const controller = this.beginRequest();
        await this.service.render();
        this.service.chatPresentation.scrollToProcessStart(document.querySelector('.nfcb-messages'));

        try {
            const plan = await this.requestAnswerPlanWithConflictRetry(
                question,
                context,
                controller.signal
            );
            this.captureConversationBinding(plan);
            const review = this.reviewFromPlan(plan, question);
            Object.assign(responseMessage, {
                role: 'assistant',
                kind: this.requiresUserReview(plan) ? 'review' : 'progress',
                content: '', question, requestId, review,
                requestedAgentMode: this.agentMode,
                requestedToolExecutionMode: 'auto',
                context: this.contextWithBinding(context),
                processSteps: this.processStepsFromPlan(plan)
            });
            if (responseMessage.kind === 'review') {
                this.pendingReview = responseMessage;
            } else {
                this.busyLabel = '근거를 확인하고 질의 언어에 맞춰 답변을 구성하고 있어요';
                const answerPromise = this.requestPlannedAnswer(responseMessage, controller.signal, null);
                this.startProcessNarration(responseMessage);
                this.scrollToBottom();
                const result = await answerPromise;
                this.captureConversationBinding(result);
                const normalized = this.resultMessage(result, question, requestId);
                Object.assign(responseMessage, normalized);
                this.lastPublicResult = normalized.publicResult;
                this.postToParent('RESULT', requestId, normalized.publicResult);
            }
        } catch (error: any) {
            if (error?.name === 'AbortError') return;
            if (responseMessage?.kind === 'progress') {
                if (this.isConversationConflict(error?.code)) this.conversationBinding = null;
                Object.assign(responseMessage, {
                    role: 'error', kind: 'error', processSteps: null,
                    content: this.errorMessage(error, '질의를 처리하지 못했습니다.'),
                    table: null, chart: null
                });
                this.emitError(error, requestId);
            } else {
                this.handleRequestError(error, requestId, question, '의도 분석을 완료하지 못했습니다.');
            }
        } finally {
            this.stopProcessNarration();
            this.finishRequest(controller);
            await this.service.render();
            this.scrollToBottom();
            this.notifyResize();
        }
    }

    public async confirmReview(message: any) {
        if (this.busy || this.pendingReview !== message) return;
        const requestId = message.requestId;
        this.pendingReview = null;
        message.kind = 'progress';
        message.content = '';
        message.processSteps = this.processStepsFromReview(message.review);
        this.busy = true;
        this.busyLabel = '데이터와 모델을 실행해 결과를 정리하고 있어요';
        const controller = this.beginRequest();
        await this.service.render();

        try {
            const confirmedReview = {
                intent: message.review.intent,
                intentLabel: message.review.intentLabel,
                agentMode: message.review.agentMode,
                agentModeLabel: message.review.agentModeLabel,
                toolExecutionMode: message.review.toolExecutionMode,
                resolvedQuery: message.review.resolvedQuery,
                secondaryIntents: message.review.secondaryIntents,
                skills: message.review.skills,
                revisionCount: 0,
                feedback: '',
                conversationBinding: message.review.conversationBinding || null
            };
            const answerPromise = this.requestPlannedAnswer(message, controller.signal, confirmedReview);
            this.startProcessNarration(message);
            const result = await answerPromise;
            this.captureConversationBinding(result);
            const normalized = this.resultMessage(result, message.question, requestId);
            Object.assign(message, normalized);
            this.lastPublicResult = normalized.publicResult;
            this.postToParent('RESULT', requestId, normalized.publicResult);
        } catch (error: any) {
            if (error?.name === 'AbortError') return;
            let failure = error;
            let replanned = false;
            if (this.isConversationConflict(error?.code)) {
                try {
                    // Never replay a confirmed ask: it may already have been
                    // claimed before the response was lost. Only issue one
                    // binding-free plan and ask the user to confirm it again.
                    const freshContext = this.contextWithoutBinding(message.context);
                    this.conversationBinding = null;
                    const plan = await this.requestAnswerPlan(
                        message.question,
                        freshContext,
                        controller.signal
                    );
                    this.captureConversationBinding(plan);
                    const review = this.reviewFromPlan(plan, message.question);
                    review.reviewReasons = [
                        '대화 상태가 변경되어 최신 분석 결과를 다시 확인해야 합니다.',
                        ...(review.reviewReasons || [])
                    ];
                    Object.assign(message, {
                        role: 'assistant', kind: 'review', content: '',
                        review,
                        context: this.contextWithBinding(freshContext),
                        processSteps: null, table: null, chart: null, publicResult: null
                    });
                    this.pendingReview = message;
                    replanned = true;
                } catch (replanError: any) {
                    failure = replanError;
                }
            }
            if (!replanned) {
                // Any failed ask invalidates the browser binding because the
                // server may have claimed the turn before losing its response.
                this.conversationBinding = null;
                Object.assign(message, {
                    role: 'error', kind: 'error',
                    content: this.errorMessage(failure, '질의를 처리하지 못했습니다.'),
                    table: null, chart: null
                });
                this.emitError(failure, requestId);
            }
        } finally {
            this.stopProcessNarration();
            this.finishRequest(controller);
            await this.service.render();
            this.scrollToBottom();
            this.notifyResize();
        }
    }

    public async reviseReview(message: any) {
        if (this.busy || this.pendingReview !== message) return;
        this.pendingReview = null;
        this.input = message.question;
        this.messages = this.messages.filter((item: any) => item !== message);
        await this.service.render();
    }

    public async resetConversation() {
        this.currentRequestId = '';
        this.alsphereChat.reset();
        this.closeSourceDetail();
        this.stopProcessNarration();
        if (this.activeController) this.activeController.abort();
        this.activeController = null;
        this.pendingReview = null;
        this.conversationBinding = null;
        this.lastPublicResult = null;
        this.busy = false;
        this.input = '';
        this.messages = [{
            role: 'assistant', kind: 'text', intro: true,
            content: '새 질문을 입력해 주세요. 의미가 모호하거나 필요한 조건이 빠진 경우에만 실행 전에 질의를 확인합니다.'
        }];
        await this.service.render();
        this.notifyResize();
    }

    private beginRequest() {
        if (this.activeController) this.activeController.abort();
        this.activeController = new AbortController();
        return this.activeController;
    }

    private finishRequest(controller: AbortController) {
        if (this.activeController === controller) this.activeController = null;
        this.busy = false;
        this.busyLabel = '';
        this.trimMessages();
    }

    private contextWithoutBinding(context: any) {
        return {
            messages: Array.isArray(context?.messages)
                ? context.messages.slice(-8)
                : []
        };
    }

    private async requestAnswerPlan(
        question: string,
        context: any,
        signal: AbortSignal
    ) {
        const form = new FormData();
        form.append('message', question);
        form.append('source', 'floating');
        form.append('context', JSON.stringify(context || { messages: [] }));
        form.append('agent_mode', this.agentMode);
        form.append('tool_execution_mode', 'auto');
        return await this.callAgent(
            '/wiz/api/page.agent/plan_answer', form, signal
        );
    }

    private async requestAnswerPlanWithConflictRetry(
        question: string,
        context: any,
        signal: AbortSignal
    ) {
        try {
            return await this.requestAnswerPlan(question, context, signal);
        } catch (error: any) {
            if (!this.isConversationConflict(error?.code)) throw error;
            this.conversationBinding = null;
            // This direct second call is deliberately not recursive: one stale
            // binding can cause at most one fresh planning request.
            return await this.requestAnswerPlan(
                question,
                this.contextWithoutBinding(context),
                signal
            );
        }
    }

    private async callAgent(url: string, form: FormData, signal: AbortSignal, onProgress: any = null) {
        const guestCsrf = this.service.auth?.status === true ? '' : this.service.auth?.session?.guest_csrf;
        if (guestCsrf) form.set('chat_csrf_token', String(guestCsrf));
        const options = { method: 'POST', body: form, signal, credentials: 'include' as RequestCredentials };
        const response = onProgress ? await this.service.chatPresentation.fetchWithProgress(url, options, onProgress) : await fetch(url, options);
        let envelope: any = null;
        try {
            envelope = await response.json();
        } catch (_error) {
            throw this.requestError(response.status, '서버 응답 형식이 올바르지 않습니다.', 'INVALID_RESPONSE');
        }
        if (!response.ok || Number(envelope?.code) !== 200) {
            const nested = envelope?.data || {};
            const detail = nested?.error || nested?.data?.error || {};
            throw this.requestError(
                response.status,
                detail.message || nested.message || '요청을 처리하지 못했습니다.',
                detail.code || nested.code || 'REQUEST_FAILED',
                typeof detail?.details?.retryable === 'boolean'
                    ? detail.details.retryable
                    : undefined,
                detail?.details?.provider,
                detail?.details?.conversationInvalidated
            );
        }
        return envelope?.data?.data || envelope?.data || {};
    }

    private async requestPlannedAnswer(message: any, signal: AbortSignal, confirmedReview: any) {
        const form = new FormData();
        form.append('message', message.question);
        form.append('source', 'floating');
        form.append('context', JSON.stringify(message.context || { messages: [] }));
        form.append('agent_mode', confirmedReview?.agentMode || message.requestedAgentMode || this.agentMode);
        form.append('tool_execution_mode', confirmedReview?.toolExecutionMode || message.requestedToolExecutionMode || 'auto');
        if (confirmedReview) {
            form.append('confirmed_review', JSON.stringify(confirmedReview));
        }
        return await this.callAgent('/wiz/api/page.agent/ask', form, signal, (snapshot: any) => {
            if (signal.aborted || this.destroyed || message.kind !== 'progress') return;
            const scroll = this.service.chatPresentation.progressScroll(
                document.querySelector('.nfcb-messages'), message, snapshot
            );
            this.service.chatPresentation.applyProgress(message, snapshot);
            void this.service.render().then(() => {
                if (!signal.aborted && !this.destroyed) scroll();
            });
        });
    }

    private requestError(
        status: number,
        message: string,
        code: string,
        retryable?: boolean,
        provider?: string,
        conversationInvalidated?: boolean
    ) {
        const error: any = new Error(message);
        error.status = Number(status || 500);
        error.code = String(code || 'REQUEST_FAILED');
        if (typeof retryable === 'boolean') error.retryable = retryable;
        error.provider = this.safeString(provider, 40).toLowerCase();
        error.conversationInvalidated = conversationInvalidated === true;
        return error;
    }

    private handleRequestError(error: any, requestId: string, question: string, fallback: string) {
        if (error?.name === 'AbortError') return;
        if (this.isConversationConflict(error?.code)) this.conversationBinding = null;
        this.messages.push({
            role: 'error', kind: 'error', question,
            content: this.errorMessage(error, fallback)
        });
        this.emitError(error, requestId);
    }

    private errorMessage(error: any, fallback: string) {
        if (Number(error?.status) === 401 || error?.code === 'AUTH_REQUIRED') {
            return this.safeString(error?.message, 500) || 'EDA·다차원 DB 변환은 로그인한 뒤 이용해 주세요.';
        }
        if (this.isConversationConflict(error?.code)) {
            return '대화 상태가 만료되었습니다. 다시 질문하면 새 문맥으로 처리합니다.';
        }
        return this.safeString(error?.message, 500) || fallback;
    }

    private isConversationConflict(code: any) {
        return [
            'CONTEXT_BINDING_INVALID', 'CONTEXT_STATE_NOT_FOUND', 'CONTEXT_REVISION_CONFLICT',
            'CONTEXT_TURN_NOT_PLANNED', 'EXECUTION_REQUEST_FINGERPRINT_MISMATCH',
            'CONVERSATION_BINDING_MISMATCH', 'AGENT_REVIEW_BINDING_MISMATCH'
        ].includes(String(code || '').trim());
    }

    private emitError(error: any, requestId: string) {
        const authRequired = Number(error?.status) === 401 || error?.code === 'AUTH_REQUIRED';
        this.postToParent('ERROR', requestId, {
            code: this.safeString(error?.code, 80) || (authRequired ? 'AUTH_REQUIRED' : 'REQUEST_FAILED'),
            message: this.errorMessage(error, '요청을 처리하지 못했습니다.'),
            retryable: !authRequired && (
                typeof error?.retryable === 'boolean'
                    ? error.retryable
                    : ![400, 403, 409, 413, 415, 422].includes(Number(error?.status))
            )
        });
    }

    private reviewFromPlan(plan: any, question: string) {
        const analysis = plan?.analysis || {};
        const agentMode = this.safeAgentMode(plan?.agentMode || analysis.agentMode || this.agentMode);
        const toolExecutionMode = this.safeToolMode(
            plan?.toolExecutionMode || analysis.toolExecutionMode || plan?.resolvedToolExecutionMode
        );
        return {
            intent: this.safeString(plan?.intent || analysis.intent || 'general', 40),
            intentLabel: this.safeString(plan?.intentLabel || analysis.intentLabel || '질문 분석', 80),
            agentMode,
            agentModeLabel: this.safeString(plan?.agentModeLabel || analysis.agentModeLabel || this.agentModeLabel(agentMode), 80),
            toolExecutionMode,
            resolvedQuery: this.safeString(analysis.resolvedQuery || analysis.normalizedQuery || question, 2000),
            secondaryIntents: this.stringList(analysis.secondaryIntents, 8, 40),
            skills: this.stringList(plan?.skillPlan || analysis.tools, 16, 80),
            executionWaves: plan?.executionWaves || analysis.executionWaves || [],
            parameterSummary: this.parameterSummary(analysis),
            reviewReasons: this.reviewReasons(plan),
            conversationBinding: this.normalizeConversationBinding(plan?.conversationBinding || analysis.conversationBinding)
        };
    }

    private requiresUserReview(plan: any) {
        const analysis = plan?.analysis || {};
        const decisions = [
            plan?.requiresUserReview,
            plan?.requiresHumanReview,
            plan?.reviewRequired,
            analysis?.requiresUserReview,
            analysis?.requiresHumanReview,
            analysis?.reviewRequired
        ];
        const explicit = decisions.find((value: any) => typeof value === 'boolean');
        if (typeof explicit === 'boolean') return explicit;
        return Boolean(
            (Array.isArray(analysis?.ambiguous) && analysis.ambiguous.length)
            || (Array.isArray(analysis?.missingInputs) && analysis.missingInputs.length)
            || String(analysis?.recognitionStatus || '').toLowerCase() === 'unknown'
        );
    }

    private reviewReasons(plan: any) {
        const analysis = plan?.analysis || {};
        const candidates = [
            plan?.reviewReasons,
            analysis?.reviewReasons,
            analysis?.ambiguous,
            analysis?.missingInputs
        ].find((value: any) => Array.isArray(value) && value.length) || [];
        return candidates.slice(0, 5).map((item: any) => {
            if (typeof item === 'string') return this.safeString(item, 240);
            return this.safeString(
                item?.question || item?.message || item?.reason || item?.label || item?.field || item?.key || item?.code,
                240
            );
        }).filter(Boolean);
    }

    private parameterSummary(analysis: any) {
        const entities = analysis?.executionRequest?.entities || analysis?.entities || {};
        if (!entities || typeof entities !== 'object' || Array.isArray(entities)) return '추출된 조건 없음';
        const labels: any = {
            lots: 'Lot', processes: '공정', equipment: '장비', parameters: '파라미터',
            analysisItems: '분석 항목', periods: '기간', metrics: '지표'
        };
        const parts = Object.keys(labels).map((key: string) => {
            const raw = entities[key];
            const values = Array.isArray(raw)
                ? raw.map((item: any) => this.safeString(item?.label || item?.key || item, 60)).filter(Boolean)
                : [];
            return values.length ? `${labels[key]}: ${values.slice(0, 3).join(', ')}` : '';
        }).filter(Boolean);
        return parts.join(' · ') || '추출된 조건 없음';
    }

    private processStepsFromPlan(plan: any) {
        const analysis = plan?.analysis || {};
        const review = this.reviewFromPlan(plan, analysis?.resolvedQuery || '');
        return this.processStepsFromReview(review);
    }

    private processStepsFromReview(review: any) {
        const tools = this.stringList(review?.skills, 16, 80);
        return [
            { id: 'context', label: '문맥 분석', detail: '최근 대화와 현재 화면 문맥을 확인했습니다.', status: 'checked' },
            { id: 'intent', label: '의도 파악', detail: review?.intentLabel || '질문 분석', status: 'checked' },
            { id: 'parameters', label: '파라미터 구분', detail: review?.parameterSummary || '추출된 조건 없음', status: 'checked' },
            { id: 'tools', label: 'Tool 실행', detail: '서버 실행 상태를 기다리고 있습니다.', status: 'queued' },
            { ...this.service.chatPresentation.resultAnalysisStep(review), status: 'queued' }
        ];
    }

    private startProcessNarration(message: any) {
        this.stopProcessNarration();
        void this.service.render();
    }

    private stopProcessNarration() {
        if (this.processNarrationTimer) window.clearInterval(this.processNarrationTimer);
        this.processNarrationTimer = null;
    }

    private resultMessage(result: any, question: string, requestId: string) {
        const unavailable = ['no_data', 'failed', 'error', 'blocked'].includes(String(result?.status || '').toLowerCase())
            || String(result?.dataScope || '').toLowerCase() === 'no_data';
        const table = unavailable ? null : this.normalizeTable(result?.table);
        const chart = unavailable || result?.artifactPolicy?.chart === false ? null : this.normalizeChart(result?.chart);
        const publicResult = this.publicResult(result, question, requestId, table, chart);
        const evidence = this.normalizeEvidence(result?.evidence);
        const citations = this.stringList(result?.citations, 100, 240);
        const meta = [
            this.safeString(result?.intentLabel || result?.analysis?.intentLabel, 80),
            this.safeString(result?.dataScope, 60),
            this.safeString(result?.dataAsOf, 60)
        ].filter(Boolean);
        return {
            role: 'assistant', kind: 'result', requestId, streaming: false,
            content: publicResult.answer,
            table, chart, meta,
            evidence, citations,
            progressNotice: '',
            progressEvents: result?.progressEvents || [], elapsedMs: result?.elapsedMs,
            answerEvidence: this.normalizeEvidence(result?.answerEvidence),
            agentMode: result?.agentMode || result?.analysis?.agentMode || '',
            resolvedAgentMode: result?.resolvedAgentMode || result?.analysis?.resolvedAgentMode || '',
            intent: result?.intent || result?.analysis?.intent || '',
            retrieval: this.service.chatPresentation.normalizeRetrieval(result?.retrieval),
            llm: result?.llm || null,
            actions: Array.isArray(result?.actions) ? result.actions : undefined,
            orchestration: result?.orchestration || null,
            sourceDetail: null,
            publicResult,
            review: null
        };
    }

    public sourceItems(message: any) {
        if (this.service.chatPresentation.isDataSearch(message)) return [];
        const evidence = Array.isArray(message?.evidence) ? message.evidence.slice(0, 100) : [];
        const citations = Array.isArray(message?.citations) ? message.citations.slice(0, 100) : [];
        const sources = [
            ...evidence.map((item: any, index: number) => ({
                id: this.safeString(item?.id, 240) || `evidence-${index + 1}`,
                citation: false,
                documentSource: this.service.chatPresentation.isDocumentSource(item),
                usage: item?.usage || 'reference', typeLabel: item?.typeLabel, title: item?.title,
                key: `evidence-${index + 1}`,
                detailApi: item?.detailApi === 'knowledge_document_evidence' ? item.detailApi : '',
                documentId: this.safeString(item?.documentId, 240),
                chunkId: this.safeString(item?.chunkId, 240),
                page: this.service.chatPresentation.evidencePage(item),
                label: (this.safeString(item?.title || item?.id, 240) || '검증 근거')
                    + (this.service.chatPresentation.evidencePage(item) ? ` · p.${this.service.chatPresentation.evidencePage(item)}` : ''),
                detail: [item?.source, item?.subtitle, item?.typeLabel]
                    .map((value: any) => this.safeString(value, 240).trim())
                    .filter(Boolean)
                    .filter((value: string, valueIndex: number, values: string[]) => values.indexOf(value) === valueIndex)
                    .join(' · '),
                excerpt: this.safeString(item?.excerpt || item?.summary, 1200),
                supports: this.safeString(item?.supports, 240),
                fields: Array.isArray(item?.fields) ? item.fields : [],
                href: this.safeSourceHref(item?.href || item?.url),
                requestId: this.safeString(item?.requestId, 160)
            })),
            ...citations.map((citation: any, index: number) => ({
                id: `citation-${index + 1}`,
                citation: true, usage: 'reference',
                key: `citation-${index + 1}`,
                ...this.service.chatPresentation.citationSource(this.safeString(citation, 240), evidence),
                detail: '서버 인용', excerpt: '', supports: '', fields: [], href: '', requestId: ''
            })).filter((item: any) => item.label)
        ];
        const normalize = (value: string) => value.replace(/\s+/g, ' ').trim();
        const evidenceLabels = new Set(evidence.map((item: any) => normalize(this.safeString(item?.title || item?.id, 240))));
        const seen = new Set<string>();
        return sources.filter((source: any) => {
            if (source.citation && evidenceLabels.has(normalize(source.label))) return false;
            const key = JSON.stringify([source.citation ? '' : source.id, source.label, source.detail, source.excerpt, source.fields, source.href, source.supports, source.requestId].map((value: any) =>
                typeof value === 'string' ? normalize(value) : value));
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }

    public answerAttribution(message: any) {
        if (message?.kind !== 'result' || message?.role !== 'assistant' || !message?.content) return null;
        return this.service.chatPresentation.attribution(message);
    }

    public sourceDetailId(message: any, source: any) {
        return `nfcb-source-${String(message?.requestId || 'answer').replace(/[^a-z0-9-]/gi, '')}-${source.key}`;
    }

    public async zoomSourceImage(message: any, change: number) {
        this.service.chatPresentation.zoomEvidenceImage(message?.sourceDetail?.pageImage, change);
        await this.service.render();
    }

    private closeSourceDetail() {
        this.sourceDetailSequence += 1;
        if (this.sourceDetailController) this.sourceDetailController.abort();
        this.sourceDetailController = null;
        if (this.sourceDetailMessage) this.sourceDetailMessage.sourceDetail = null;
        this.sourceDetailMessage = null;
    }

    public async toggleSourceDetail(message: any, source: any) {
        if (this.destroyed || message?.kind !== 'result' || !this.messages.includes(message)) return;
        const sameSource = this.sourceDetailMessage === message && message.sourceDetail?.key === source?.key;
        this.closeSourceDetail();
        if (sameSource) {
            await this.service.render();
            return;
        }
        const remote = source?.detailApi === 'knowledge_document_evidence' && source.documentId;
        const view = {
            ...source, loading: Boolean(remote), error: '', pageImage: null,
            excerpt: source.excerpt,
            fields: source.fields,
            supports: source.supports
        };
        message.sourceDetail = view;
        this.sourceDetailMessage = message;
        const sequence = this.sourceDetailSequence;
        const controller = remote ? new AbortController() : null;
        this.sourceDetailController = controller;
        await this.service.render();
        if (!remote || !controller) return;
        if (this.destroyed || sequence !== this.sourceDetailSequence || !this.messages.includes(message)) return;
        try {
            const params = this.service.chatPresentation.evidencePreviewParams(source);
            const form = new FormData();
            for (const [key, value] of Object.entries(params)) form.append(key, String(value));
            const preview = await this.callAgent('/wiz/api/page.agent/knowledge_document_evidence_preview', form, controller.signal);
            if (this.destroyed || sequence !== this.sourceDetailSequence || !this.messages.includes(message)) return;
            view.pageImage = this.service.chatPresentation.evidenceImage(preview, source);
            view.loading = false;
        } catch (error: any) {
            if (error?.name === 'AbortError' || this.destroyed || sequence !== this.sourceDetailSequence || !this.messages.includes(message)) return;
            view.loading = false;
            view.error = error?.message || '원본 PDF 페이지를 불러오지 못했습니다. 문서 형식과 접근 권한을 확인해 주세요.';
        } finally {
            if (this.sourceDetailController === controller) this.sourceDetailController = null;
        }
        if (!this.destroyed && sequence === this.sourceDetailSequence) await this.service.render();
    }

    private normalizeEvidence(value: any) {
        if (!Array.isArray(value)) return [];
        return value.slice(0, 100).map((item: any) => ({
            ...this.safeObject(item, ['id', 'type', 'typeLabel', 'title', 'subtitle', 'source', 'dataScope', 'supports', 'requestId', 'detailApi', 'documentId', 'chunkId', 'usage'], 240),
            page: this.service.chatPresentation.evidencePage(item),
            excerpt: this.safeString(item?.excerpt || item?.summary || item?.snippet, 1200),
            href: this.safeSourceHref(item?.href || item?.url),
            fields: item?.fields && typeof item.fields === 'object' && !Array.isArray(item.fields)
                ? Object.entries(item.fields)
                    .filter(([key, field]: any) => !this.sensitiveSourceKey(key)
                        && field !== null && field !== undefined && typeof field !== 'object')
                    .slice(0, 8)
                    .map(([key, field]: any) => ({ label: this.safeString(key, 80), value: this.safeString(field, 240) }))
                : []
        })).filter((item: any) => item.id || item.title);
    }

    private sensitiveSourceKey(value: any) {
        return /servicekey|apikey|password|secret|token|authorization|cookie/i.test(String(value || '').replace(/[^a-z0-9]/gi, ''));
    }

    private safeSourceHref(value: any) {
        const href = this.safeString(value, 2000).trim();
        if (!href || (!/^https?:\/\//i.test(href) && !/^\/(?!\/)/.test(href))) return '';
        try {
            const url = new URL(href, window.location.origin);
            if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return '';
            let sensitiveQuery = false;
            url.searchParams.forEach((_value: string, key: string) => {
                if (this.sensitiveSourceKey(key)) sensitiveQuery = true;
            });
            if (sensitiveQuery || (href.startsWith('/') && url.origin !== window.location.origin)) return '';
            if (this.sensitiveSourceKey(decodeURIComponent(url.hash))) return '';
            return href.startsWith('/') ? `${url.pathname}${url.search}${url.hash}` : url.href;
        } catch (_error) {
            return '';
        }
    }

    private publicResult(result: any, question: string, requestId: string, table: any, chart: any) {
        const analysis = result?.analysis || {};
        const intent = this.safeString(result?.intent || analysis.intent || 'general', 40);
        const searchProvider = this.safeString(
            result?.searchProvider || analysis.searchProvider, 40
        ).toLowerCase();
        const searchResourceType = this.safeString(
            result?.searchResourceType || analysis.searchResourceType, 20
        ).toLowerCase();
        const searchResourceKind = this.safeString(
            result?.searchResourceKind || analysis.searchResourceKind, 20
        ).toLowerCase();
        const expectedTool = searchResourceType === 'dataset' ? 'dataset.search' : 'data.search';
        const actions = Array.isArray(result?.actions) ? result.actions : [];
        const bandiSearch = searchProvider === 'bandi'
            && ['data', 'dataset'].includes(searchResourceType)
            && actions.some((action: any) =>
                action?.name === expectedTool && action?.status === 'completed'
            );
        let kind = bandiSearch
            ? (searchResourceType === 'dataset' ? 'dataset_search' : 'data_search')
            : 'analysis';
        if (!bandiSearch && analysis.requiresModel) kind = 'model';
        if (kind === 'analysis' && chart) kind = 'visualization';
        const output: any = {
            kind,
            question: this.safeString(question, 2000),
            answer: this.safeString(result?.answer || result?.content || '답변을 생성하지 못했습니다.', MAX_TEXT_LENGTH),
            summary: this.safeString(result?.summary || result?.answer || result?.content, 1200),
            intent,
            intentLabel: this.safeString(result?.intentLabel || analysis.intentLabel, 80),
            dataScope: this.safeString(result?.dataScope, 60),
            dataAsOf: this.safeString(result?.dataAsOf, 60),
            source: this.safeString(result?.source, 240),
            table,
            chart,
            model: this.normalizeModel(result),
            metrics: this.normalizeMetrics(result),
            provenance: this.normalizeProvenance(result),
            requestId,
            retrieval: this.service.chatPresentation.normalizeRetrieval(result?.retrieval)
        };
        if (bandiSearch && searchResourceKind !== 'equipment') {
            const executionRequest = result?.executionRequest || analysis.executionRequest || {};
            const reviewedQuery = this.safeString(
                analysis.resolvedQuery || executionRequest.searchTerms?.[0] || question,
                1000
            );
            const reviewedEntities = executionRequest.entities || analysis.entities || {};
            output.searchHandoff = this.searchHandoff(
                searchResourceType,
                reviewedQuery,
                reviewedEntities,
                executionRequest.periods
            );
        }
        return output;
    }

    private searchHandoff(resourceType: string, question: string, entities: any, reviewedPeriods?: any[]) {
        const periods = Array.isArray(reviewedPeriods)
            ? reviewedPeriods.slice(0, 4)
            : Array.isArray(entities?.periods) ? entities.periods.slice(0, 4) : [];
        return {
            screen: resourceType === 'dataset' ? 'dataset-search' : 'detail-log-search',
            resourceType,
            query: this.safeString(question, 1000),
            filters: {
                lots: this.stringList(entities?.lots, 10, 80),
                processes: this.stringList(entities?.processes, 10, 80),
                equipment: this.stringList(entities?.equipment, 10, 120),
                parameters: this.stringList(
                    entities?.analysisItems || entities?.parameters,
                    10,
                    80
                ),
                periods: periods.map((item: any) => this.normalizePeriod(item))
            }
        };
    }

    private normalizeModel(result: any) {
        const source = result?.domainModel || result?.selectedModel || result?.model || result?.llm?.model || result?.llm || {};
        if (typeof source === 'string') {
            const id = this.safeString(source, 160);
            return id ? { id } : null;
        }
        if (!source || typeof source !== 'object' || Array.isArray(source)) return null;
        const model = this.safeObject(source, ['id', 'model', 'name', 'version', 'provider', 'status'], 160);
        return Object.keys(model).length ? model : null;
    }

    private normalizeProvenance(result: any) {
        const source = result?.provenance || {};
        const provenance = this.safeObject(source, ['source', 'dataset', 'version', 'dataScope', 'dataAsOf'], 240);
        if (result?.source) provenance.source = this.safeString(result.source, 240);
        if (result?.dataScope) provenance.dataScope = this.safeString(result.dataScope, 60);
        if (result?.dataAsOf) provenance.dataAsOf = this.safeString(result.dataAsOf, 60);
        return Object.keys(provenance).length ? provenance : null;
    }

    private normalizeMetrics(result: any) {
        const source = result?.metrics || result?.answerQuality?.metrics || result?.orchestration?.metrics || {};
        const metrics = this.safeObject(source, [
            'count', 'confidence', 'accuracy', 'precision', 'recall', 'f1',
            'mae', 'rmse', 'r2', 'anomalyCount', 'total'
        ], 80);
        return Object.keys(metrics).length ? metrics : null;
    }

    private normalizeTable(value: any) {
        if (!value || !Array.isArray(value.columns) || !Array.isArray(value.rows)) return null;
        const columns = value.columns.slice(0, MAX_TABLE_COLUMNS).map((column: any, index: number) => ({
            key: this.safeString(typeof column === 'object' ? column.key : column, 80) || `column${index + 1}`,
            label: this.safeString(typeof column === 'object' ? column.label || column.key : column, 80) || `열 ${index + 1}`
        }));
        if (!columns.length) return null;
        const rows = value.rows.slice(0, MAX_TABLE_ROWS).map((row: any) => columns.map((column: any, index: number) =>
            this.tableValue(Array.isArray(row) ? row[index] : row?.[column.key])
        ));
        return rows.length ? { columns, rows } : null;
    }

    private normalizeChart(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
        if (['no_data', 'failed', 'error', 'blocked'].includes(String(value.status || '').toLowerCase())) return null;
        if (String(value.dataScope || '').toLowerCase() === 'no_data') return null;
        const raw = Array.isArray(value.points) ? value.points.slice(0, MAX_CHART_POINTS) : [];
        const labels = Array.isArray(value.labels) ? value.labels : [];
        const points = raw.map((point: any, index: number) => {
            const objectPoint = point && typeof point === 'object' && !Array.isArray(point);
            const rawValue = objectPoint ? point.value ?? point.y : point;
            if (!['number', 'string'].includes(typeof rawValue) || String(rawValue).trim() === '') return null;
            const numeric = Number(rawValue);
            if (!Number.isFinite(numeric)) return null;
            return {
                label: this.safeString(objectPoint ? point.label ?? point.x : labels[index], 80) || `${index + 1}`,
                value: numeric,
                unit: this.safeString(objectPoint ? point.unit || value.unit : value.unit, 20)
            };
        }).filter(Boolean);
        if (!points.length) return null;
        const count = (item: any) => typeof item === 'number' && Number.isSafeInteger(item) && item >= 0 ? item : null;
        const returnedRows = count(value.coverage?.returnedRows);
        const providerTotal = count(value.coverage?.providerTotal);
        const coverageLabel = value.coverage ? [
            `표시 ${points.length}개`,
            returnedRows === null ? '' : `반환 ${returnedRows}행`,
            providerTotal === null ? '' : `전체 ${providerTotal}행`
        ].filter(Boolean).join(' · ') : '';
        return {
            type: this.safeString(value.type, 40) || 'chart',
            title: this.safeString(value.title, 120) || '시각화 결과',
            unit: this.safeString(value.unit, 20),
            caption: this.safeString(value.caption, 600),
            coverageLabel,
            source: this.safeString(value.source || value.provenance?.source || value.provenance?.provider, 160),
            points
        };
    }

    private normalizeConversationBinding(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
        const normalized = {
            conversationId: String(value.conversationId || '').toLowerCase(),
            turnId: String(value.turnId || '').toLowerCase(),
            contextRevision: Number(value.contextRevision),
            contextFingerprint: String(value.contextFingerprint || '').toLowerCase(),
            executionRequestFingerprint: String(value.executionRequestFingerprint || '').toLowerCase()
        };
        if (
            !/^conv-[0-9a-f]{32}$/.test(normalized.conversationId)
            || !/^turn-[0-9a-f]{32}$/.test(normalized.turnId)
            || !Number.isSafeInteger(normalized.contextRevision)
            || normalized.contextRevision < 0
            || !/^[0-9a-f]{64}$/.test(normalized.contextFingerprint)
            || !/^[0-9a-f]{64}$/.test(normalized.executionRequestFingerprint)
        ) return null;
        return normalized;
    }

    private captureConversationBinding(value: any) {
        const binding = this.normalizeConversationBinding(value?.conversationBinding || value?.analysis?.conversationBinding);
        if (binding) this.conversationBinding = binding;
    }

    private conversationContext() {
        const rows = this.messages
            .filter((item: any) => ['user', 'assistant'].includes(item.role) && item.content)
            .slice(-8)
            .map((item: any) => ({ role: item.role, content: this.safeString(item.content, 1200) }));
        return this.contextWithBinding({ messages: rows });
    }

    private contextWithBinding(context: any) {
        const output: any = { messages: Array.isArray(context?.messages) ? context.messages.slice(-8) : [] };
        if (this.conversationBinding) output.conversationBinding = this.conversationBinding;
        return output;
    }

    public publishAgain(message: any) {
        if (!message?.publicResult || !REQUEST_ID_PATTERN.test(message.requestId)) return;
        this.postToParent('RESULT', this.requestId(), message.publicResult);
    }

    public openSearch(message: any) {
        const handoff = message?.publicResult?.searchHandoff;
        if (!handoff || !REQUEST_ID_PATTERN.test(message.requestId)) return;
        this.postToParent('OPEN_SEARCH', this.requestId(), { searchHandoff: handoff });
    }

    public searchButtonLabel(handoff: any) {
        return handoff?.resourceType === 'dataset' ? '데이터셋 검색에서 보기' : '세부 데이터 검색에서 보기';
    }

    public messageClass(message: any) {
        if (message?.role === 'user') return 'is-user';
        if (message?.role === 'error') return 'is-error';
        if (message?.kind === 'review') return 'is-review';
        return 'is-assistant';
    }

    public agentModeLabel(mode: string) {
        return ({ auto: '자동 Agent', data_search: '데이터 검색', simple: '단순 질의', ai_model: 'AI 모델 사용' } as any)[this.safeAgentMode(mode)] || '자동 Agent';
    }

    public skillLabels(skills: any[]) {
        const labels: any = {
            'rag.search': '문서 검색', 'process.search': '공정 데이터 검색',
            'data.search': 'BANDI 공정 데이터 검색', 'dataset.search': 'BANDI 데이터셋 검색',
            'model.predict': 'AI 모델', 'analytics.analyze': '결과 분석',
            'trace.compare': 'Trace Analysis', 'chart.render': '시각화',
            'report.compose': '결과 요약'
        };
        return (skills || []).map((item: string) => labels[item] || item).join(' · ') || '답변 생성';
    }

    public toolLabel(tool: string) {
        return this.skillLabels([tool]);
    }

    public processStatusLabel(status: string) {
        return ({ checked: '확인', running: '진행 중', submitted: '실행 요청됨', queued: '대기' } as any)[status] || '대기';
    }

    public showBusyIndicator() {
        return this.busy && !this.messages.some((message: any) => message?.kind === 'progress');
    }

    private tableValue(value: any) {
        if (typeof value === 'number' && Number.isFinite(value)) {
            return value.toLocaleString(undefined, { maximumSignificantDigits: 10 });
        }
        return this.safeString(value, 240);
    }

    public chartValue(point: any) {
        return `${Number(point?.value || 0).toLocaleString(undefined, { maximumSignificantDigits: 6 })}${point?.unit || ''}`;
    }

    private chartRange(points: any[]) {
        const values = (points || []).map((point: any) => Number(point.value)).filter(Number.isFinite);
        const maximum = Math.max(0, ...values);
        const minimum = Math.min(0, ...values);
        return { maximum, span: maximum - minimum || 1 };
    }

    public chartZeroPosition(points: any[]) {
        const range = this.chartRange(points);
        return `${range.maximum / range.span * 100}%`;
    }

    public chartBarStyle(value: number, points: any[]) {
        const range = this.chartRange(points);
        return {
            top: `${(range.maximum - Math.max(0, value)) / range.span * 100}%`,
            height: `${Math.abs(value) / range.span * 100}%`
        };
    }

    private safeAgentMode(value: any) {
        const mode = String(value || '').toLowerCase();
        if (['virtual_metrology', 'anomaly'].includes(mode)) return 'ai_model';
        return ['auto', 'data_search', 'simple', 'ai_model'].includes(mode) ? mode : 'auto';
    }

    private safeToolMode(value: any) {
        const mode = String(value || '').toLowerCase();
        return ['auto', 'sequential', 'parallel'].includes(mode) ? mode : 'auto';
    }

    private safeString(value: any, maximum: number) {
        if (value === null || value === undefined) return '';
        if (typeof value === 'object') {
            if (value.label !== undefined) value = value.label;
            else if (value.title !== undefined) value = value.title;
            else return '';
        }
        return String(value).replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '').slice(0, maximum);
    }

    private stringList(value: any, count: number, maximum: number) {
        if (!Array.isArray(value)) return [];
        return value.slice(0, count).map((item: any) => this.safeString(item, maximum)).filter(Boolean);
    }

    private safeObject(value: any, keys: string[], maximum: number) {
        const output: any = {};
        if (!value || typeof value !== 'object' || Array.isArray(value)) return output;
        keys.forEach((key: string) => {
            const item = this.safeString(value[key], maximum);
            if (item) output[key] = item;
        });
        return output;
    }

    private normalizePeriod(value: any) {
        const output = this.safeObject(value, ['label', 'key'], 100);
        const start = this.safeIsoDate(value?.start);
        const end = this.safeIsoDate(value?.end);
        if (start) output.start = start;
        if (end) output.end = end;
        return output;
    }

    private safeIsoDate(value: any) {
        const match = /^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/.exec(String(value || '').trim());
        if (!match) return '';
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const parsed = new Date(Date.UTC(year, month - 1, day));
        if (
            parsed.getUTCFullYear() !== year
            || parsed.getUTCMonth() !== month - 1
            || parsed.getUTCDate() !== day
        ) return '';
        return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }

    private trimMessages() {
        if (this.messages.length > 18) this.messages = [this.messages[0], ...this.messages.slice(-17)];
    }

    private scrollToBottom() {
        window.setTimeout(() => {
            if (this.destroyed) return;
            const target = document.querySelector('.nfcb-messages') as HTMLElement | null;
            if (!target) return;
            const latest = this.messages[this.messages.length - 1];
            if (latest?.role === 'assistant' && latest.kind === 'result') {
                const entries = target.querySelectorAll<HTMLElement>('[data-chat-role]');
                this.service.chatPresentation.scrollToAnswerStart(target, entries.item(entries.length - 1));
            } else {
                target.scrollTop = target.scrollHeight;
            }
        }, 0);
    }

    private notifyResize() {
        if (!this.bridgeReady) return;
        window.setTimeout(() => {
            const height = Math.max(420, Math.min(760, document.documentElement.scrollHeight || 620));
            this.postToParent('RESIZE', null, { width: 440, height });
        }, 0);
    }
}

export default PageChatbotEmbedComponent;